import { z } from 'zod'
import { tenantRoleSchema } from '../enums/tenant-role.enum.js'
import { tenantStatusSchema } from '../enums/tenant-status.enum.js'
import { uuidSchema } from '../validators/params.js'

export const tenantUserDtoSchema = z.object({
  id: uuidSchema,
  email: z.string().email(),
  name: z.string(),
})

export type TenantUserDto = z.infer<typeof tenantUserDtoSchema>

/** One tenant the signed-in user belongs to. The role is for rendering only. */
export const tenantMembershipDtoSchema = z.object({
  tenantId: uuidSchema,
  tenantSlug: z.string(),
  tenantName: z.string(),
  /** Suspended organizations are read-only in the dashboard. */
  tenantStatus: tenantStatusSchema,
  role: tenantRoleSchema,
})

export type TenantMembershipDto = z.infer<typeof tenantMembershipDtoSchema>

export const tenantSessionDtoSchema = z.object({
  user: tenantUserDtoSchema,
  memberships: z.array(tenantMembershipDtoSchema),
})

export type TenantSessionDto = z.infer<typeof tenantSessionDtoSchema>

export const tenantLoginResponseDtoSchema = tenantSessionDtoSchema.extend({
  accessToken: z.string(),
})

export type TenantLoginResponseDto = z.infer<typeof tenantLoginResponseDtoSchema>

/** What the accept-invitation page shows before the invitee commits. */
export const invitationPreviewDtoSchema = z.object({
  tenantId: uuidSchema,
  tenantName: z.string(),
  email: z.string().email(),
  role: tenantRoleSchema,
  expiresAt: z.string().datetime(),
  /** True when this email already has a dashboard login (sign in to accept). */
  accountExists: z.boolean(),
})

export type InvitationPreviewDto = z.infer<typeof invitationPreviewDtoSchema>
